/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeocodingResultDto } from '../models/GeocodingResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GeocodingControllerService {
    /**
     * Search for locations using Nominatim geocoding
     * @param query Search query string
     * @returns GeocodingResultDto OK
     * @throws ApiError
     */
    public static search(
        query: string,
    ): CancelablePromise<Array<GeocodingResultDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/geocoding/search',
            query: {
                'query': query,
            },
        });
    }
    /**
     * Reverse geocode coordinates to address
     * @param lat Latitude
     * @param lon Longitude
     * @returns GeocodingResultDto OK
     * @throws ApiError
     */
    public static reverse(
        lat: number,
        lon: number,
    ): CancelablePromise<GeocodingResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/geocoding/reverse',
            query: {
                'lat': lat,
                'lon': lon,
            },
        });
    }
}
